package fr.manyverse.app.infrastructure.imagepicker

import fr.manyverse.app.domain.image.SupportedImageFormats
import fr.manyverse.app.domain.model.ImageData
import io.github.vinceglb.filekit.dialogs.FileKitType

internal actual val imagePickerType: FileKitType = FileKitType.File(SupportedImageFormats.fileExtensions)

internal actual suspend fun ensureSupportedFormat(image: ImageData): ImageData = image
